export default __webpack_public_path__ + "static/media/male.9db76242.jpg";